import { cn } from '../../../lib/utils'
import type { StoreProviderDefinition } from './store-providers'

export function ProviderMark({
  provider,
  size = 'md',
}: {
  provider: StoreProviderDefinition
  size?: 'sm' | 'md' | 'lg'
}) {
  const Logo = provider.Logo

  if (Logo) {
    // Real brand logo (e.g. the four-colour eBay wordmark). Wordmarks are wide,
    // so the chip becomes a rounded rectangle: same height as the square letter
    // chips of sibling providers, width grows with the logo's aspect ratio.
    const chipClass = {
      sm: 'h-8 rounded-lg px-1.5',
      md: 'h-11 rounded-xl px-2',
      lg: 'h-16 rounded-xl px-3',
    }[size]
    const logoClass = {
      sm: 'h-3.5 w-auto',
      md: 'h-[18px] w-auto',
      lg: 'h-7 w-auto',
    }[size]

    return (
      <span
        className={cn(
          'inline-flex shrink-0 items-center justify-center',
          chipClass,
          provider.markClassName,
        )}
      >
        <Logo className={logoClass} />
      </span>
    )
  }

  const sizeClass = {
    sm: 'h-8 w-8 rounded-lg text-sm',
    md: 'h-11 w-11 rounded-xl text-base',
    lg: 'h-16 w-16 rounded-xl text-2xl',
  }[size]

  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center font-bold tracking-tight',
        sizeClass,
        provider.markClassName,
      )}
    >
      {provider.mark}
    </span>
  )
}
